// NOM-004 NO-04: only opaque patient IDs are persisted; no PHI (names, MRN,
// clinical data) is written to browser storage. Enrichment happens at read
// time via the API.
import { clinicalStorageKey } from './clinicalSession'

const storageKey = () => clinicalStorageKey('hms-recent-patient-ids')
const MAX_ENTRIES = 6

export function recordRecentPatient(patientId: string): void {
  try {
    const existing = getRecentPatientIds()
    const updated = [patientId, ...existing.filter((id) => id !== patientId)].slice(0, MAX_ENTRIES)
    localStorage.setItem(storageKey(), JSON.stringify(updated))
  } catch {
    // localStorage unavailable — silently skip.
  }
}

export function getRecentPatientIds(): string[] {
  try {
    const raw = localStorage.getItem(storageKey())
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'string') : []
  } catch {
    return []
  }
}

export function clearRecentPatients(): void {
  try {
    localStorage.removeItem(storageKey())
  } catch {
    // no-op
  }
}
